var render = function render(){var _vm=this,_c=_vm._self._c;return _c('UIRadioGroup',{attrs:{"value":_vm.formValues.timeInterval,"options":_vm.optionsData},on:{"change":_vm.handleChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }